/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { HYRouter, HYDevice } from '@hy-hybrid/kiwi-js-sdk';
import btn0 from './pages/index/hooks/Head/images/btns/btn 2_00000.png';
import btn2 from './pages/index/hooks/Head/images/btns/btn 2_00002.png';
import btn4 from './pages/index/hooks/Head/images/btns/btn 2_00004.png';
import btn6 from './pages/index/hooks/Head/images/btns/btn 2_00006.png';
import btn8 from './pages/index/hooks/Head/images/btns/btn 2_00008.png';
import btn10 from './pages/index/hooks/Head/images/btns/btn 2_000010.png';
import btn12 from './pages/index/hooks/Head/images/btns/btn 2_000012.png';
import btn14 from './pages/index/hooks/Head/images/btns/btn 2_000014.png';
import btn16 from './pages/index/hooks/Head/images/btns/btn 2_000016.png';
import btn18 from './pages/index/hooks/Head/images/btns/btn 2_000018.png';
import btn20 from './pages/index/hooks/Head/images/btns/btn 2_000020.png';
import btn22 from './pages/index/hooks/Head/images/btns/btn 2_000022.png';

import newbtn0 from './pages/index/hooks/Head/images/btn/btn_01.png';
import newbtn2 from './pages/index/hooks/Head/images/btn/btn_02.png';
import newbtn4 from './pages/index/hooks/Head/images/btn/btn_04.png';
import newbtn6 from './pages/index/hooks/Head/images/btn/btn_06.png';
import newbtn8 from './pages/index/hooks/Head/images/btn/btn_08.png';
import newbtn10 from './pages/index/hooks/Head/images/btn/btn_010.png';
import newbtn12 from './pages/index/hooks/Head/images/btn/btn_012.png';
import newbtn14 from './pages/index/hooks/Head/images/btn/btn_014.png';
import newbtn16 from './pages/index/hooks/Head/images/btn/btn_016.png';
import newbtn18 from './pages/index/hooks/Head/images/btn/btn_018.png';
import newbtn20 from './pages/index/hooks/Head/images/btn/btn_020.png';
import newbtn22 from './pages/index/hooks/Head/images/btn/btn_022.png';
import newbtn24 from './pages/index/hooks/Head/images/btn/btn_024.png';
import newbtn26 from './pages/index/hooks/Head/images/btn/btn_026.png';
import newbtn28 from './pages/index/hooks/Head/images/btn/btn_028.png';
import newbtn30 from './pages/index/hooks/Head/images/btn/btn_030.png';
import newbtn32 from './pages/index/hooks/Head/images/btn/btn_032.png';
import newbtn34 from './pages/index/hooks/Head/images/btn/btn_034.png';
import newbtn36 from './pages/index/hooks/Head/images/btn/btn_036.png';
import newbtn38 from './pages/index/hooks/Head/images/btn/btn_038.png';
import newbtn40 from './pages/index/hooks/Head/images/btn/btn_040.png';
import newbtn42 from './pages/index/hooks/Head/images/btn/btn_042.png';
import newbtn44 from './pages/index/hooks/Head/images/btn/btn_044.png';
import newbtn46 from './pages/index/hooks/Head/images/btn/btn_046.png';

const imgList = [
  btn0,
  btn2,
  btn4,
  btn6,
  btn8,
  btn10,
  btn12,
  btn14,
  btn16,
  btn18,
  btn20,
  btn22,
];
const imgListNew = [
  newbtn0,
  newbtn2,
  newbtn4,
  newbtn6,
  newbtn8,
  newbtn10,
  newbtn12,
  newbtn14,
  newbtn16,
  newbtn18,
  newbtn20,
  newbtn22,
  newbtn24,
  newbtn26,
  newbtn28,
  newbtn30,
  newbtn32,
  newbtn34,
  newbtn36,
  newbtn38,
  newbtn40,
  newbtn42,
  newbtn44,
  newbtn46,
];

/**
 * @file utils
 */
const { canOpenApp } = HYRouter;
const { getDeviceInfo } = HYDevice;
/**
 * 随机数
 */
export const randomInteger = () => Math.floor(Math.random() * 10);

/**
 * 获取随机字母
 */
export const randomAlphabet = () => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  return alphabet[Math.floor(Math.random() * alphabet.length)];
};

/**
 * 获取虎牙分享口令
 * @param huyaWord 虎牙口令
 * @param content 分享文案
 * @returns
 */
export const generateHuyaShareWord = (huyaWord: string, content: string) => {
  if (!huyaWord) return '';
  // 规则 随机数x.x + 空格 + 两个随机小写字母 + :/, + #虎牙口令# + 文案
  // const firstInt = randomInteger();
  // const secondInt = randomInteger();
  // const firstLetter = randomAlphabet();
  // const secondLetter = randomAlphabet();
  // return `${firstInt}.${secondInt} ${firstLetter}${secondLetter}:/, #${huyaWord}# ${content}`;
  return `${content} s@h.r $1 ${huyaWord}`;
};

export const toDecimal = (x, type = 1) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = type ? Math.round(x * 100) / 100 : Math.round(x * 10) / 10;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  if (type) {
    while (s.length <= rs + 2) {
      s += '0';
    }
  } else {
    while (s.length <= rs + 1) {
      s += '0';
    }
  }
  return s;
};

export const regFenToYuan = (fen, type = 1) => {
  // let num: any = fen;
  let num: any = fen * 0.01;
  num += '';
  const reg =
    num.indexOf('.') > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, '$1');
  num = toDecimal(num, type);
  return num;
};

declare const window: any;
export const reportFuc = (url, desc, props) => {
  try {
    window.report({
      eid: url,
      eid_desc: desc,
      prop: props,
    });
  } catch (e) {
    console.log('上报出错!', url, desc);
  }
};

const addZero = (m: any) => (m < 10 ? '0' + m : m);
export const formatDate = (dates) => {
  const time = new Date(dates);
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return addZero(m) + '.' + addZero(d);
};

export const formatDate2 = (time) => {
  const now = new Date().getTime();
  const createTime = +new Date(time);

  const oneMin = 60 * 1000;
  const oneHour = 60 * oneMin;
  const oneDay = 24 * oneHour;
  const twoDay = oneDay * 2;
  const compareTime = now - createTime;

  const todayZeroTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime();

  const lastDayZeroTime = todayZeroTime - oneDay;
  const secondDayBeforeZeroTime = todayZeroTime - twoDay;

  // 今天发布的
  if (createTime > todayZeroTime) {
    if (compareTime < oneMin) {
      return "刚刚";
    }
    if (compareTime < oneHour) {
      return `${Math.floor(compareTime / oneMin)}分钟前`;
    }
    if (compareTime < oneDay) {
      return `${Math.floor(compareTime / oneHour)}小时前`;
    }
    return false;
  }
  const detail = getDetailDate(createTime);

  const dayDetail = `${detail.getHour()}:${detail.getMin()}`;
  const monthDetail = `${detail.getMonth()}-${detail.getDay()}`;

  if (createTime > lastDayZeroTime) {
    // 昨天
    return `昨天${dayDetail}`;
  }
  if (createTime > secondDayBeforeZeroTime) {
    // 前天
    return `前天${dayDetail}`;
  }
  const t = new Date(createTime);
  const isCurrentYear = detail.getYear() == t.getFullYear();

  if (isCurrentYear) {
    return `${monthDetail} ${dayDetail}`;
  }
  return `${`${detail.getYear()}-${monthDetail}`}${dayDetail}`;
};

export const getDetailDate = (timeStamp) => {
  const date = timeStamp ? new Date(timeStamp) : new Date(); // 如果date为13位不需要乘1000
  const Y = date.getFullYear();
  const M = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

  return {
    getYear() {
      return Y;
    },
    getMonth() {
      return M;
    },
    getDay() {
      return D;
    },
    getHour() {
      return h;
    },
    getMin() {
      return m;
    },
    getDetail() {
      return [Y, M, D].join("-");
    },
  };
}

export const formatDate3 = (dates) => {
  // const date = new Date(dates);
  // const YY = date.getFullYear() + '.';
  // const MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.';
  // const DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  // return YY + MM + DD;
  const time = new Date(dates);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  // const s = time.getSeconds();
  return (
    y +
    '年' +
    addZero(m) +
    '月' +
    addZero(d) +
    '日' +
    addZero(h) +
    ':' +
    addZero(mm)
  );
};

export const canOpen = (type: string) =>
  new Promise((resolve) => {
    const isWx = type !== 'qq';
    getDeviceInfo().then((rsp) => {
      const isPad =
        (navigator.userAgent.toLowerCase().match(/iPad/i) as any) == 'ipad';
      const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const isIos = isIOS || isPad;
      const wxWup = isIos ? 'weixin://' : 'com.tencent.mm';
      const qqWup = isIos ? 'mqq://' : 'com.tencent.mobileqq';
      console.log('canOpenApp请求', isWx ? wxWup : qqWup)
      canOpenApp({
        appkey: isWx ? wxWup : qqWup,
      })
        .then((resp) => {
          console.log('canOpenApp', resp);
          if (isIos) {
            resolve(true);
          } else {
            resolve(!!resp.canOpen);
          }
        })
        .catch((err) => {
          console.log('canOpenApp', err);
          resolve(false);
        });
    });
  });

const loadImage: any = (src) => {
  const p = new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      // 加载时执行resolve函数
      resolve(img);
    };
    img.onerror = function () {
      reject(src);
    };
    img.src = src;
  });
  return p;
};
export async function preLoadImg() {
  // eslint-disable-next-line space-infix-ops
  const arr: any = [];
  // eslint-disable-next-line space-infix-ops
  for (let i = 0; i < 12;) {
    await loadImage(imgList[i]).then((img) => {
      arr.push(img);
    });
    i += 1;
  }
  return arr;
}

export async function preLoadNewImg() {
  // eslint-disable-next-line space-infix-ops
  const arr: any = [];
  // eslint-disable-next-line space-infix-ops
  for (let i = 0; i < 24;) {
    await loadImage(imgListNew[i]).then((img) => {
      arr.push(img);
    });
    i += 1;
  }
  return arr;
}

/**
 * 获取链接某个参数
 * @param name
 * @returns 字符串或者null
 */
export const getURLParam = (name: string) => {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i')
  );
  return value ? decodeURIComponent(value[1]) : value;
};

/**
 * 获取某个cookie
 * @param cookieName
 * @returns 字符串或者null
 */
export const getCookie = (cookieName) => {
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');
  for (let idx = 0; idx < cookies.length; idx += 1) {
    const cookie = cookies[idx];
    let start = cookie.indexOf(cookieName + '=');
    if (start === -1 || start > 1) continue;
    start += cookieName.length + 1;
    return cookie.substring(start);
  }
  return null;
};

export const ruleText = (iOld: boolean, time) => {
  const oldText = [
    '参与本活动前，请您详细阅读活动规则及相关条款。凡参与本活动，则视为您已阅读、理解并同意活动规则及注意事项全部内容。平台有权根据运营实际情况和需要对以下活动规则进行修改。',
    // `1. 本期活动时间：${ruleTime[0]} - ${ruleTime[1]}，本活动所有时间均以北京时间为准。`,
    // `1. 本期活动时间：2022年01月01日00:00-2022年02月28日23:59，本活动所有时间均以北京时间为准。`,
    `1. 本期活动时间：即日起 - ${time}，本活动所有时间均以北京时间为准。`,
    '2. 邀请对象：',
    '（1）新朋友：指设备及登录账号均从未打开虎牙直播App的朋友；',
    '（2）回归朋友：指设备及登录账号均在上个月1日至昨日未打开虎牙直播App的朋友（例如：4月1日至5月1日未打开虎牙直播App的朋友可在5月2日被邀请成功）。',
    '3. 活动玩法：',
    '（1）获得奖励：活动时间内，每成功邀请一位新朋友或回归朋友（以下或称“被邀请者"），你（以下或称为“邀请者”）和被邀请者都将获得奖励（奖励内容详情以获得奖励时的页面展示为准）。',
    '（2）奖励细则：',
    'A.邀请新朋友奖励：邀请新朋友通过你的邀请二维码、口令或分享链接首次登录完成邀请关系绑定后你可获得第一阶段奖励，当新朋友连续2天登录时你可获得第二阶段奖励，当新朋友连续7天登录时你可获得第三阶段奖励，连续登录天数自新朋友邀请关系绑定之日起计算，如新朋友连续登录天数中断，则您无法获取第二、三阶段的奖励；',
    'B.邀请回归朋友奖励：邀请回归朋友完成邀请关系绑定后你可获得奖励，邀请回归朋友只有邀请奖励，无后续阶段奖励；',
    '（3）奖励上限：每个用户每天通过本活动最多获得2000经验值；每个用户每天在全平台内参与各类活动合计最多获得24万积分。',
    '（4）邀请方式：你可将在本活动邀请生成的二维码、口令或分享链接分享给被邀请者，被你邀请的朋友通过你的二维码/分享链接跳转至App或复制口令手动进入App，如被邀请者符合新朋友或回归朋友要求，则视为你邀请成功。',
    '（5）邀请限制：每个用户只能被成功邀请一次，同一个登录账号或同一个设备都视为同一个用户；为保证活动期间系统稳定，被您成功邀请的用户数量将根据您邀请的用户质量有不同上限，超出数量上限的邀请行为属于无效邀请，邀请者及被邀请者均不能获得任何奖励。',
    '4. 特别说明',
    '（1）可参与对象：本活动仅部分受邀用户可参与，未受邀用户无法访问活动页面，具体以页面展示为准。',
    '（2）本活动暂不支持未满18周岁的用户参与。',
    '（3）在参与本活动时，平台需要访问用户所使用设备的剪切板，读取其中包含的口令、链接等（以平台内实际提供的分享方式为准），以实现跳转、分享、活动联动等功能或服务，剪切板仅回传与平台有关的口令或链接信息，不会回传与本活动无关的其他用户个人信息。',
    '（4）为依法履行代扣代缴义务，将在提现用户同意后需收集其身份证号、真实姓名，上述信息属于敏感个人信息，提现用户可拒绝提供，如果拒绝提供，提现用户可能无法完成提现，但不影响其他功能的正常使用。平台保证前述信息仅用于纳税用途。',
    '5．活动名词解释：',
    '（1）现金：可提现至微信账户的现金奖励，每笔现金的有效期均为获得之日起30天，用户未在有效期内完成提现视为自愿放弃现金奖励，平台不给与任何形式的补偿。',
    '（2）虎粮：可用于赠送主播增加亲密度，有效期为7天，1元=10个虎粮。',
    '（3）银豆：目前可用于赠送礼物、修改昵称、参与种豆、参与上电视弹幕抽奖，1元=10000银豆。',
    '（4）积分：目前可用于兑换积分商城的商品（商品持续扩展中）。',
    '（5）经验值：用于提升用户等级获得超级特权，详情可见任务中心。',
    '6．提现规则：',
    '（1）平台为本活动提供的提现额度以当日提现页面提供的具体提现额度为准，每次提现可选择其中一档提现额度进行提现，当次提现后的剩余金额可在后续满足提现额度时申请提现。',
    '（2）如通过微信提现，每个虎牙账号仅支持绑定唯一身份实名信息和唯一微信账号（该微信账号与虎牙账号的身份证实名信息需保持一致），暂不支持换绑。请确保按要求操作且信息准确无误，以免提现失败。因用户原因而非本产品原因导致的提现失败，视为用户放弃已获现金奖励，平台不给与任何形式的补偿亦无需承担责任。',
    '（3）在提现过程中，为了更好的保护用户的账号及相关资产的安全，平台可能会限制用户提现的虎牙账号数量，并根据实际情况增加或提高安全验证手段。如用户无法通过安全验证将无法提现，视为用户放弃已获现金奖励，本产品不给与任何形式的补偿亦无需承担责任。',
    '（4）活动高峰期间内，由于网络拥堵等原因，可能发生用户短期内无法提现的情况，本产品将尽最大努力恢复提现功能。如显示「提现失败」，建议确认绑定的微信号/实名认证/短信验证等信息是否准确、是否符合参与本活动的条件、微信账号是否可用等。如有其他疑问，请按照以下路径联系本产品：我的-帮助与反馈-客服帮助。',
    '（5）用户因参加本活动缴纳的税费暂由本产品承担，本产品可能会根据本活动实际开展情况修改为由用户个人承担税费，用户提现金额以实际到账金额为准。提现金额预计在用户完成提现操作后的3-5个工作日内进入用户指定账户，如遇双休日、节假日或提现高峰期，提现到账时间可能有延迟，具体以实际到账时间为准。如显示「提现成功」但3-5个工作日后仍未到账，请按照以下路径联系本产品，反馈问题时请提供活动内的提现记录：我的-帮助与反馈-客服帮助。',
    '7．您不得以任何不正当手段或舞弊方式参与本活动。一经发现，本平台有权采取限制登录、封禁账号、撤销活动资格、限制提现、账号金额清零、限制再次注册使用等措施，亦有权收回您已领取的奖励，并追讨已使用的奖励或与奖励同等价值的金额，并保留追究您的责任的权利。如因此给您造成损失，本平台不进行任何赔偿或补偿。不正当手段及舞弊行为包括但不限于：下载非官方客户端；使用模拟器、插件、外挂等非法工具扫码、下载、安装、注册、登录、赠与、领取任何奖励、提现；注册多个账号；篡改设备数据；恶意牟利等扰乱平台秩序；使用插件、外挂、系统或第三方工具对本平台及本活动进行干扰、破坏、修改或施加其他影响及本平台认为的其他不正当手段。',
  ];
  const newText = [
    '参与本活动前，请您详细阅读活动规则及相关条款。凡参与本活动，则视为您已阅读、理解并同意活动规则及注意事项全部内容。平台有权根据运营实际情况和需要对以下活动规则进行修改。',
    '一、邀请相关：',
    ' 1、可被邀请朋友：',
    ' （1）新朋友：指设备及登录账号均从未访问过虎牙直播App的朋友。',
    ' （2）回归朋友：指设备及登录账号均在上月1日至昨日均未访问过虎牙直播App的非新朋友（例如：4月1日至5月2日未访问虎牙直播App的非新朋友可在5月3日被邀请为回归朋友）。',
    ' （3）老朋友：指设备或登录账号在上月1日至昨日有访问过虎牙直播App，但当天还未访问过虎牙直播App的朋友。',
    ' 2、有效邀请方式：',
    '  你可将在本活动邀请生成的二维码、口令或分享链接分享给被邀请者，被你邀请的朋友在下载虎牙直播App后通过你的二维码/分享链接跳转至App或复制口令手动进入App，如被邀请者符合"可被邀请朋友"要求并完成看直播任务，则视为你邀请成功。',
    ' 3、邀请特殊限制：',
    ' （1）如邀请的是新朋友/回归朋友，每个用户只能在本活动被成功邀请一次，同一个登录账号或同一个设备都视为同一个用户。',
    ' （2）如邀请的是老朋友，每个老朋友每天最多被邀请1次，且必须在当天首次访问虎牙直播App前接受邀请才有效；',
    '二、邀请奖励相关：',
    ' 1、邀请人奖励',
    ' （1）邀请新朋友/回归朋友：新朋友/回归朋友受邀看直播后你可获得现金及道具礼包，朋友连续多日看直播还可获得更多现金奖励（奖励内容以页面展示及邀请人私信通知为准）。',
    ' （2）邀请老朋友：老朋友受邀看直播后你可获得现金及道具礼包（奖励内容以页面展示及邀请人私信通知为准）。',
    ' 2、被邀请人奖励：被邀请朋友受邀看直播后可获得道具礼包奖励（奖励内容以页面展示及邀请人私信通知为准）。',
    ' 3、奖励审核：活动发放的所有奖励均会有最长24小时的审核周期，审核通过后会实际发放至账户，审核失败则不会进行发放（“审核中”状态的现金也会被扣除）。',
    ' 4、特殊奖励上限：每个用户每天通过本活动最多获得2000经验值；每个用户每天在全平台内参与各类活动合计最多获得24万积分。',
    '三、特别说明',
    '（1）可参与对象：本活动仅部分受邀用户可参与，未受邀用户无法访问活动页面，具体以页面展示为准。',
    '（2）本活动暂不支持未满18周岁的用户参与。',
    '（3）在参与本活动时，平台需要访问用户所使用设备的剪切板，读取其中包含的口令、链接等（以平台内实际提供的分享方式为准），以实现跳转、分享、活动联动等功能或服务，剪切板仅回传与平台有关的口令或链接信息，不会回传与本活动无关的其他用户个人信息。',
    '（4）为依法履行代扣代缴义务，将在提现用户同意后需收集其身份证号、真实姓名，上述信息属于敏感个人信息，提现用户可拒绝提供，如果拒绝提供，提现用户可能无法完成提现，但不影响其他功能的正常使用。平台保证前述信息仅用于纳税用途。',
    '（5）为保证活动期间系统稳定，被您成功邀请的用户数量将根据您邀请的用户质量有不同上限，超出数量上限的邀请行为属于无效邀请，邀请者及被邀请者均不能获得任何奖励。',
    '四、活动名词解释：',
    '（1）现金：可提现至微信账户的现金奖励，每笔现金的有效期均为获得之日起30天，用户未在有效期内完成提现视为自愿放弃现金奖励，平台不给与任何形式的补偿。',
    '（2）虎粮：可用于赠送主播增加亲密度，有效期为7天，每10虎粮价值1元。',
    '（3）银豆：目前可用于赠送礼物、修改昵称、参与种豆、参与上电视弹幕抽奖，每10000银豆价值1元。',
    '（4）积分：目前可用于兑换积分商城的商品（商品持续扩展中），每1000积分价值1元。',
    '（5）经验值：用于提升用户等级获得超级特权，详情可见任务中心，每100经验价值1元',
    '五、提现规则：',
    '（1）平台为本活动提供的提现额度以当日提现页面提供的具体提现额度为准，每次提现可选择其中一档提现额度进行提现，当次提现后的剩余金额可在后续满足提现额度时申请提现。',
    '（2）如通过微信提现，每个虎牙账号仅支持绑定唯一身份实名信息和唯一微信账号（该微信账号与虎牙账号的身份证实名信息需保持一致），暂不支持换绑。请确保按要求操作且信息准确无误，以免提现失败。因用户原因而非本产品原因导致的提现失败，视为用户放弃已获现金奖励，平台不给与任何形式的补偿亦无需承担责任。',
    '（3）在提现过程中，为了更好的保护用户的账号及相关资产的安全，平台可能会限制用户提现的虎牙账号数量，并根据实际情况增加或提高安全验证手段。如用户无法通过安全验证将无法提现，视为用户放弃已获现金奖励，本产品不给与任何形式的补偿亦无需承担责任。',
    '（4）活动高峰期间内，由于网络拥堵等原因，可能发生用户短期内无法提现的情况，本产品将尽最大努力恢复提现功能。如显示「提现失败」，建议确认绑定的微信号/实名认证/短信验证等信息是否准确、是否符合参与本活动的条件、微信账号是否可用等。如有其他疑问，请按照以下路径联系本产品：我的-帮助与反馈-客服帮助。',
    '（5）用户因参加本活动缴纳的税费暂由本产品承担，本产品可能会根据本活动实际开展情况修改为由用户个人承担税费，用户提现金额以实际到账金额为准。提现金额预计在用户完成提现操作后的3-5个工作日内进入用户指定账户，如遇双休日、节假日或提现高峰期，提现到账时间可能有延迟，具体以实际到账时间为准。如显示「提现成功」但3-5个工作日后仍未到账，请按照以下路径联系本产品，反馈问题时请提供活动内的提现记录：我的-帮助与反馈-客服帮助。 ',
    '六、您不得以任何不正当手段或舞弊方式参与本活动。一经发现，本平台有权采取限制登录、封禁账号、撤销活动资格、限制提现、账号金额清零、限制再次注册使用等措施，亦有权收回您已领取的奖励，并追讨已使用的奖励或与奖励同等价值的金额，并保留追究您的责任的权利。如因此给您造成损失，本平台不进行任何赔偿或补偿。不正当手段及舞弊行为包括但不限于：下载非官方客户端；使用模拟器、插件、外挂等非法工具扫码、下载、安装、注册、登录、赠与、领取任何奖励、提现；注册多个账号；篡改设备数据；恶意牟利等扰乱平台秩序；使用插件、外挂、系统或第三方工具对本平台及本活动进行干扰、破坏、修改或施加其他影响及本平台认为的其他不正当手段。',
    '八、平台现行有效的《虎牙直播用户协议》、《虎牙直播隐私政策》等平台规则同样适用于本活动，本活动规则内容与前述平台规则相冲突的，以本活动规则为准。本活动规则未约定的内容，以前述平台规则为准。',
  ];
  return iOld ? oldText : newText;
};
